import {
  FULL_PRECISION,
  TooltipProps,
  Tooltip,
} from '@make-software/cspr-design';
import React from 'react';
import styled from 'styled-components';
import { formatTokenAmount } from '../../utils/ft-token-amount';
const SpanWrapper = styled.span(() => ({
  cursor: 'pointer',
}));

const formatFullPrecisionAmount = (amount: string) => {
  const formattedAmount = formatTokenAmount(amount, FULL_PRECISION);
  const [fullAmount, fraction] = formattedAmount.split('.');

  if (!fraction) {
    return formattedAmount;
  }

  const trimmedAmount = fraction.replace(/0+$/, '');

  return trimmedAmount ? `${fullAmount}.${trimmedAmount}` : fullAmount;
};

export const FullPrecisionTooltip = ({
  amount,
  symbol,
  children,
}: TooltipProps & { amount: string; symbol: string | undefined }) => {
  const tooltipContent = `${formatFullPrecisionAmount(amount)} ${symbol || ''}`;
  return (
    <Tooltip
      tooltipContent={tooltipContent}
      scale={'xs'}
      lineHeight={'xs'}
      padding={'10px'}
    >
      <SpanWrapper>{children}</SpanWrapper>
    </Tooltip>
  );
};

export default FullPrecisionTooltip;
